export const CATEGORIES = [
    {
        id: "program",
        title: "Program Basics",
        icon: "🎓",
        blurb: "What the program is, who it’s for, and what students learn.",
        image:
            "https://images.unsplash.com/photo-1509062522246-3755977927d7?q=80&w=1200&auto=format&fit=crop"
    },
    {
        id: "enrollment",
        title: "Enrollment",
        icon: "🗓️",
        blurb: "Registration steps, age groups, schedules, and seats.",
        image:
            "https://images.unsplash.com/photo-1523580846011-d3a5bc25702b?q=80&w=1200&auto=format&fit=crop"
    },
    {
        id: "fees",
        title: "Fees & Support",
        icon: "💳",
        blurb: "Pricing, discounts, and scholarship information.",
        image:
            "https://images.unsplash.com/photo-1454179083322-198bb4daae1b?q=80&w=1200&auto=format&fit=crop"
    },
    {
        id: "logistics",
        title: "Logistics",
        icon: "📍",
        blurb: "Locations, parking, makeup classes, online options.",
        image:
            "https://images.unsplash.com/photo-1517632298125-f1ca6f2de6d1?q=80&w=1200&auto=format&fit=crop"
    },
    {
        id: "coaching",
        title: "Coaching",
        icon: "🧑‍🏫",
        blurb: "Who coaches, safety, and how sessions are run.",
        image:
            "https://images.unsplash.com/photo-1553877522-43269d4ea984?q=80&w=1200&auto=format&fit=crop"
    },
    {
        id: "policies",
        title: "Policies",
        icon: "📝",
        blurb: "Refunds, attendance, and community standards.",
        image:
            "https://images.unsplash.com/photo-1519389950473-47ba0277781c?q=80&w=1200&auto=format&fit=crop"
    }
];

export const FAQS = [
    { id: "what",   cat: "program",    q: "What is Almaden Voices?", a: "A youth public speaking program that builds confidence through weekly practice, coaching, and a short showcase speech." },
    { id: "who",    cat: "program",    q: "Who can join?", a: "Grades K–9. Programs vary by grade level, and specific eligibility is listed for each session." },
    { id: "length", cat: "program",    q: "How long is the program?", a: "Core series runs 4 weeks (75–90 minutes each); we also host seasonal workshops." },

    { id: "enroll", cat: "enrollment", q: "How do I enroll my student?", a: "Complete the registration form; we’ll confirm dates/availability and next steps by email." },
    { id: "age",    cat: "enrollment", q: "Are levels grouped by age?", a: "Yes—by grade band. We may adjust groupings to balance seat counts and comfort." },

    { id: "fees",   cat: "fees",       q: "What are the fees?", a: "Fees vary by session length. Scholarships are available—please contact us if cost is a barrier." },

    { id: "where",  cat: "logistics",  q: "Where are sessions held?", a: "Primarily in Almaden Valley, San Jose. Occasional online cohorts are offered." },
    { id: "miss",   cat: "logistics",  q: "What if we miss a class?", a: "We share catch-up notes and optional prompts. If seats allow, we’ll try to fit a makeup." },

    { id: "coach",  cat: "coaching",   q: "Who are the coaches?", a: "Trained student leaders (with adult supervision) using a consistent, supportive curriculum." },

    { id: "final",  cat: "program",    q: "Is there a final speech?", a: "Yes—each student presents a short talk in week 4. Families are welcome to cheer." },

    { id: "refund", cat: "policies",   q: "What is your refund policy?", a: "Full refund up to 7 days before start; partial thereafter if your seat can be filled." },
    { id: "contact",cat: "policies",   q: "How can I contact the team?", a: "Email almadenvoices@gmail.com or use the Contact page—we reply within 24–48 hours." }
];

